<template>
  <el-collapse v-model="masterRatesManagement.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="master-rates-management-search-section" id="master-rates-management-search-section">
      <el-form
        id="master-rates-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('masterRates.chargeCodes.name')">
              <autocomplete
                :model.sync="searchForm.chargeCodeId"
                :url="urlChargeCode"
                :placeholder="$t('masterRates.chargeCodes.searchChargeCodeOrName')"
                labelField="name"
                popperAppendToBody
                labelFieldLastWithDash="code"
                valueField="id"
                ref="autocomplete-input"
              />
            </el-form-item>
          </el-col>

          <el-col :md="8" :sm="12" :xs="24">
            <el-form-item :label="$t('masterRates.expired')" >
              <expired-select :value="masterRatesManagement.actualFilters.expiredService"  v-model="searchForm.expiredMasterRates" />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item :label="$t('masterRates.warehouse')" >
                    <select-list
                        :value.sync="searchForm.warehouse"
                        :url="urlWarehouses"
                        :default-all="true"
                        label-field="code"
                        value-field="id"
                        ref="filter-warehouse-select" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              :content="$t('common.search')"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <el-button
                id="invoices-search-section-form-button"
                class="button-action-default"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import { MASTER_RATES_MANAGEMENT_SEARCH } from '@/store/actions';
import Autocomplete from '@/components/Autocomplete/index';
import SelectList from '@/components/Select/SelectList';
import ExpiredSelect from './components/expiredService/ExpiredServiceSelect';

export default {
  name: 'SearchFilters',
  components: {
    SelectList, ExpiredSelect, Autocomplete
  },
  computed: {
    ...mapGetters(['masterRatesManagement']),
  },
  data() {
    return {
      searchForm: {
        chargeCodeId: null,
        regionId: null,
        warehouse: null,
        expiredMasterRates: false,
      },
      urlChargeCode: apiConstants.END_POINTS.BILLING.CHARGE_CODE_LIST_SEARCH,
      urlWarehouses: apiConstants.END_POINTS.BILLING.WAREHOUSE,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.searchForm.expiredService = this.masterRatesManagement.actualFilters.expiredService;
    });
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(MASTER_RATES_MANAGEMENT_SEARCH, this.searchForm);
    },
  }
};
</script>
